package dev.lingvo.site.components.studio.compose

/** Bounds a single reusable canvas and the largest simultaneous encode/upload stage. */
data class BitmapBudget(val width: Int, val height: Int, val maxPngBytes: Long = 8L * 1024 * 1024) {
    init {
        require(width > 0 && height > 0) { "Output dimensions must be positive" }
        require(maxPngBytes >= 0) { "PNG budget must not be negative" }
    }

    /** Three output-bounded images may coexist while drawing; every bitmap closes before encoding. */
    val peakBytes: Long get() {
        val pixels = width.toLong() * height
        val renderStage = pixels * 16 + maxPngBytes
        val encodeStage = pixels * 11 + height + maxPngBytes * 2
        return maxOf(renderStage, encodeStage)
    }

    /** Unsupported heap telemetry leaves the fixed resource bound authoritative. */
    fun pauseMillis(usedBytes: Long?, heapLimit: Long?): Int =
        if (usedBytes != null && heapLimit != null && heapLimit > 0 && usedBytes.toDouble() / heapLimit > 0.7) 500 else 0
}
